import styled, {css} from 'styled-components'

export const StyledAgendaDateRoomFields = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: ${spacing * 4}px;
    `
)

export const StyledReadonlyDate = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 600;
        color: ${palette.neutral[500]};
        text-transform: capitalize;
    `
)
